module.exports = __webpack_public_path__ + "static/img/header2.79006124.jpg";